import { set, omit } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import {
  createFetchManyHandler,
  createFetchOneHandler
} from '../../../../helpers/reducerRoutineCrudHandler';
import {
  paginationState,
  resetPaginationState
} from '../../../../helpers/pagination';
import {
  fetchClients,
  fetchClient,
  fetchClientByBarcode
} from '../../../sagas/routines';
import {
  clearGuests,
  removeGuest,
  guestsOnChangePage,
  guestsOnChangeOrder,
  guestsOnChangeQuery
} from '../../../actions/components/guest-list';

const initialState = {
  all: {},
  fetching: false,
  fetched: false,
  fetchingError: null,
  pagination: paginationState(),
  order: 'id:asc',
  query: {}
};

const clearGuestsHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    all: {},
    pagination: resetPaginationState(state.pagination)
  })
});

const removeGuestHandler = action => ({
  [action.toString()]: (state, { payload: id }) => ({
    ...state,
    all: omit(id, state.all)
  })
});

const guestsOnChangePageHandler = action => ({
  [action.toString()]: (state, { payload: page }) =>
    set('pagination.currentPage', page, state)
});

const guestsOnChangeOrderHandler = action => ({
  [action.toString()]: (state, { payload: order }) => set('order', order, state)
});

const guestsOnChangeQueryHandler = action => ({
  [action.toString()]: (state, { payload }) => set('query', payload, state)
});

export default createReducer(initialState, {
  ...createFetchManyHandler(fetchClients),
  ...createFetchOneHandler(fetchClient),
  ...createFetchOneHandler(fetchClientByBarcode),
  ...clearGuestsHandler(clearGuests),
  ...removeGuestHandler(removeGuest),
  ...guestsOnChangePageHandler(guestsOnChangePage),
  ...guestsOnChangeOrderHandler(guestsOnChangeOrder),
  ...guestsOnChangeQueryHandler(guestsOnChangeQuery)
});
